import React, { useEffect, useState } from "react";
import {  Box } from "@chakra-ui/react";
import './orgnizationProfile.css'; 
import { useDispatch, useSelector } from "react-redux";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import OrgnizationProfileForm from "components/allForm/OrgnizationProfile/orginizationProfileForm";
import { fetchAsyncGetOrganization } from "redux/organizationSlice";
import { fetchAsyncGetOrganizationLogo } from "redux/organizationSlice";
import { fetchAsyncGetOrganizationModuleType } from "redux/organizationModuleSlice";
import PaymentLimit from "components/allForm/OrgnizationProfile/paymentLimit";
import OrganizationSalesInvoiceType from "components/allForm/OrgnizationProfile/SalesInvoiceModule/orgSalesInvoiceType";
import OrganizationModuleTypeForm from "components/allForm/OrgnizationProfile/expenseModule/organizationModuleTypeForm";

const OrgnizationProfile = () => {
  
  const currUser = useSelector((state) => state.auth.currUser);
  const [role,setRole] = useState('')  
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [organizationData, setOrganizationData] = useState([])
  const organizationList = useSelector((state) => state.organizationData);
  const moduleType = useSelector((state) => state.moduleType);
  const [activeTab,setActiveTab] = useState('profile')

  useEffect(()=>{
    if(currUser && currUser?.auth){

      const auth = currUser?.auth;
      const roleObj = auth && auth?.length > 0 && auth.find((item)=> item?.module === 'Organization Profile');
      if(roleObj){
        setRole(roleObj?.access)
      }
    }
   
  },[currUser])

  const getOrganization = ()=>{
    setLoading(true); 
    dispatch(fetchAsyncGetOrganization())
      .then(() => {
        setLoading(false); 
      })
      .catch((error) => {
        setLoading(false); 
      });
      dispatch(fetchAsyncGetOrganizationLogo())
      dispatch(fetchAsyncGetOrganizationModuleType())
  }
  useEffect(() => {
    getOrganization()
  }, []);

    const handleRefresh = ()=>{
      getOrganization();
      setLoading(false)
    }
    useEffect(()=>{
      if(organizationList && organizationList?.length){
        setOrganizationData(organizationList)
      }
    },[organizationList])

   if (loading) {
    return (
      <SpinnerLoader/>
    );
  }
  return (
    <>
      <Box  className="mx-0 orginazation-profile" >
      <Box display="flex" className="heading">
        
        <Box display="flex"  className="tab-btn">
        
          <Box className="tab-btn-div">
          <div
              className={`div-btn ${
                activeTab === "profile" ? "active-tab-btn" : ""
              }`}
              onClick={() => setActiveTab("profile")}
            >
              Organization Profile
            </div>
            <div
              className={`div-btn ${
                activeTab === "payment" ? "active-tab-btn" : ""
              }`}
              onClick={() => setActiveTab("payment")}
            >
              Payment Limit
            </div>
           
          </Box>
        
        </Box>
        </Box>
              
      <Box className="orgnization-form" style={{overflowY:'auto'}}>
        {activeTab === 'profile' &&
        <>
        <div className="form-data">

        <OrgnizationProfileForm
          editItem={organizationData}
          isEditForm={(organizationList && organizationList?.length)? 'true' : 'false'}
          role={role}
          handleRefresh={handleRefresh}
          loading={(value)=>setLoading(value)}
        />
        </div>
        <div className="org_exp_form">
          <OrganizationModuleTypeForm
            handleRefresh={handleRefresh}
            allModule={moduleType}
          />

          <OrganizationSalesInvoiceType />
        </div>
        </>
        }
      </Box>
      {activeTab === 'payment' &&
      <Box style={{width:'75%'}} paddingLeft={5}>
        <PaymentLimit 
           orgData={organizationData}
        />
      </Box>
        }
      </Box>
      
    </>
  );
};

export default OrgnizationProfile
